<div class="beneficiaries-list-container container">
    <div class="beneficiaries-list-header pt-4 w-100">
        <div class="w-100">
            <h5 class="app-module-title">Beneficiarios</h5>
        </div>
    </div>
    <div class="beneficiaries-list-content">
        <mat-spinner *ngIf="itsFetching" mode="indeterminate"></mat-spinner>
        <div *ngIf="beneficiariesList.items.length > 0 && !itsFetching; else noBeneficiary" class="d-flex flex-column gap-3 w-100">
            <p class="x-small-label text-uppercase spaced-label m-0 pb-3">Todos ({{ beneficiariesList.items.length }})</p>
            <div matRipple
                class="d-flex flex-row justify-content-between align-items-center card-theme-color theme-shadow rounded-4 p-4 w-100"
                 *ngFor="let item of beneficiariesList.items">
                <div>
                    <p class="x-small-text text-uppercase spaced-label">
                        {{ item.nombre }} {{ item.apellido_p }}
                        {{ item.apellido_m }}
                    </p>
                    <p class="small-label">Termina en **{{ item.cuenta_r | cardLast4 }}</p>
                    <p class="small-label">{{ item.desc_tarjeta | cardDesc }}</p>
                    <p class="small-label">
                        Tickets:
                        <span>{{item.tot_ticket}}</span>
                    </p>
                    <p class="medium-text">
                        <span>{{ item.tot_importe | currency }}</span>
                    </p>
                </div>
                <button (click)="openRemoveCardModal(item.cuenta_r)"
                        mat-icon-button
                        class="attenuated-accent-red-btn">
                    <span class="material-symbols-rounded">delete</span>
                </button>
                <!--                    <mat-divider></mat-divider>-->
            </div>
        </div>
    </div>
    <div class="beneficiaries-list-bottom">
        <button mat-flat-button
                class="role-action-btn w-100"
                [routerLink]="['/app/beneficiaries/add']"
                matTooltip="Agregar beneficiario">
            <span class="material-symbols-rounded">add</span>
            Agregar
        </button>
    </div>
</div>
<ng-template #deleteBeneficiaryModal>
    <div class="remove-beneficiary p-3">
        <div class="remove-beneficiary-header">
            <p class="medium-text fw-bold">
                ¿Desea eliminar la siguiente tarjeta que termina en {{ selectedCardNo | cardLast4 }}?
            </p>
        </div>
        <div class="remove-beneficiary-content">
            <p class="small-label">
                Puedes eliminar esta tarjeta y reasignarla mas adelante.
            </p>
        </div>
        <mat-divider></mat-divider>
        <div class="remove-beneficiary-bottom multiple-separation-bottom-actions">
            <button mat-flat-button
                (click)="deleteBeneficiary()"
                class="bg-transparent text-danger w-100">
                Confirmar
            </button>
            <mat-divider></mat-divider>
            <button mat-flat-button
                (click)="dismiss()"
                class="bg-transparent w-100">
                Cancelar
            </button>
        </div>
    </div>
</ng-template>
<ng-template #noBeneficiary>
    <div class="no-beneficiaries-layout container">
        <div class="d-flex flex-column align-items-center">
            <img class="mb-3"
                 src="../../../../assets/img/link_new_account.svg"
                 width="128"
                 height="128"
                 alt>
            <h5 class="app-module-title text-center">
                Agrega beneficiarios a tu cuenta
            </h5>
            <p class="small-label text-center">
                Presiona el boton 'Agregar' para registrar un nuevo beneficiario.
            </p>
<!--            <button mat-flat-button-->
<!--                    class="role-action-btn mt-3"-->
<!--                    [routerLink]="['/app/beneficiaries/add']"-->
<!--                    matTooltip="Agregar beneficiario">-->
<!--                <span class="material-symbols-rounded">add</span>-->
<!--                Agregar-->
<!--            </button>-->
        </div>
    </div>
</ng-template>

